/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block/base-teaser-tile-block.fragment';
import {TeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/teaser-tile.fragment';

export const FullTeaserTileBlockFragment = gql`
  ${BaseTeaserTileBlockFragment}
  ${TeaserTileFragment}

  fragment FullTeaserTileBlockFragment on TeaserTileBlock {
    ...BaseTeaserTileBlockFragment

    teaserTilesCollection {
      items {
        __typename
        ... on TeaserTile {
          ...TeaserTileFragment
        }
      }
    }
  }
`;
